import * as React from 'react'
import { currentLang, languages, saveLocale } from '../../i18nInit'
import { Lang } from '../../services/api.types'
import Box from '@material-ui/core/Box'
import { isNative } from '../../common/helpers/isNative'
import YumSmallSelect from '../YumSmallSelect/YumSmallSelect'

export interface ILanguageSelectionState {
  lang: Lang
  isDrawerOpen: boolean
}

interface IYumLanguageSelection {
  display?: any
  onSubmit?(lang: Lang): void
}

export class YumLanguageSelection extends React.PureComponent<IYumLanguageSelection, ILanguageSelectionState> {
  state = {
    lang: currentLang,
    isDrawerOpen: false,
  }

  /*setLocale = (lang: Lang) => () => {
    saveLocale(lang)

    if (isNative()) {
      window.location.reload()
    } else {
      // Refresh the page and remove lang query parameter (if present).
      window.location.href = window.location.href.split('?')[0]
    }
  }

  handleClick = (lang: Lang) => () => {
    this.setState({ lang: lang })
  }

  toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event &&
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return
    }

    this.setState({ isDrawerOpen: open })
  }*/

  handleLangChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const { value } = event.target as { value: Lang }
    this.setState({ lang: value }, () => {
      saveLocale(value)

      if (this.props.onSubmit) {
        this.props.onSubmit(value)
      } else {
        if (isNative()) {
          window.location.reload()
        } else {
          // Refresh the page and remove lang query parameter (if present).
          window.location.href = window.location.href.split('?')[0]
        }
      }
    })
  }

  render() {
    //const currentLang = getLocale()
    //const currentLangThreeLetters = languages?.find((l) => l.lang === currentLang)?.threeLetterCode
    //const iOS = Capacitor.getPlatform() === 'ios'

    return (
      <Box display={this.props.display}>
        <YumSmallSelect variant="outlined" value={this.state.lang} onChange={this.handleLangChange}>
          {languages.map(({ lang, name }, index) => (
            <option key={lang} value={lang}>
              {name}
            </option>
          ))}
        </YumSmallSelect>
        {/*<YumButton
          variant="outlined"
          size="small"
          style={{ width: 'auto', minWidth: 57, fontSize: 12, borderRadius: 32, lineHeight: '23px', marginRight: 0 }}
          onClick={this.toggleDrawer(true)}
        >
          {currentLangThreeLetters}
        </YumButton>
        <SwipeableDrawer
          anchor="bottom"
          open={this.state.isDrawerOpen}
          onClose={this.toggleDrawer(false)}
          onOpen={this.toggleDrawer(true)}
          disableBackdropTransition={!iOS}
          disableDiscovery={iOS}
        >
          <List>
            {languages.map(({ lang, name, flag }, index) => {
              const labelId = `lang-${lang}`
              return (
                <ListItem
                  key={lang}
                  role={undefined}
                  button
                  disableRipple
                  onClick={this.handleClick(lang)}
                  selected={this.state.lang === lang}
                >
                  <ListItemIcon>{this.state.lang === lang ? <CheckedCircleIcon /> : <EmptyCircleIcon />}</ListItemIcon>
                  <ListItemText id={labelId} primary={name} />
                  <ListItemIcon style={{ minWidth: 'auto' }}>
                    <img src={flag} alt={`${name} flag`} />
                  </ListItemIcon>
                </ListItem>
              )
            })}
          </List>

          <YumButton onClick={this.setLocale(this.state.lang)}>{t`Save`}</YumButton>
        </SwipeableDrawer>*/}
      </Box>
    )
  }
}
